module.exports = __webpack_public_path__ + "img/qr.226fb435.png";